import { StripeElementsOptionsMode } from '@stripe/stripe-js'

import { useDarkMode } from '@/lib/hooks/use-dark-mode'

export const useStripeElementsDefaultOptions = (
  options: StripeElementsOptionsMode,
): StripeElementsOptionsMode => {
  const isDarkMode = useDarkMode()
  return {
    appearance: {
      theme: isDarkMode ? 'night' : 'stripe',
      variables: {
        fontFamily: 'ui-sans-serif, system-ui, sans-serif',
        colorPrimary: 'rgb(249, 88, 40)',
        colorSuccess: 'rgb(30, 171, 82)',
        colorWarning: 'rgb(253, 42, 59)',
        colorBackground: 'rgb(var(--background))',
        colorText: 'rgb(var(--foreground))',
        colorDanger: 'rgb(var(--destructive))',
        focusOutline: 'rgba(0, 0, 0, 0.1)',
        focusBoxShadow: '0 0 0 2px rgba(0, 0, 0, 0.1)',
        borderRadius: '16px',
      },
    },
    ...options,
  }
}
